import { MediaTipState, InitialMediaTipState } from './state';
import { MediaTipAction, MediatipActionType, GetMediatipsActionDone, GetMediatipBubDataActionDone } from './actions';
import { MediaTipTask, MediaTipActionDone, MeditipActionResultEnum } from '@app/common/models/mediatips.models';
import { SimpleResult, SimpleResultError } from '@app/common/models/simpleResult.model';
import { BubDataResult } from 'FoxxyInterfaces';

export function reduceMediatips(state: MediaTipState = InitialMediaTipState, action: MediaTipAction): MediaTipState {
  switch (action.type) {


    case MediatipActionType.GetBubDataByEansActionDone:

      return {
        ...state,
        isLoading: false,
        bubDataList: [...state.bubDataList.filter(f=> action.payload.bubDataList.filter(e=> e.ean == f.ean).length == 0 ), ...action.payload.bubDataList]
      };

    case MediatipActionType.GetMediatipActionDone:
      return {
        ...state,
        isLoading: false,
        mediatipActionDone: <MediaTipActionDone>{ result: action.payload.mediatip, actionResult: MeditipActionResultEnum.laden }
      };
    case MediatipActionType.GetSoMaContactsActionDone:
      return {
        ...state,
        isLoading: false,
        SoMaContacts: action.payload.somaContacts
      };
    case MediatipActionType.GetMediatipBubDataAction:
      return {
        ...state,
        isLoadingbubData: true
      };
    case MediatipActionType.GetMediatipBubDataActionDone:
      return getMediatipBubDataActionDone(state, action);

    case MediatipActionType.RemoveMediaTipDoneObjectfromStoreAction:
      return {
        ...state,
        isLoading: false,
        bubData: <BubDataResult>{},
        isLoadingbubData: false,
        mediatipActionDone: <MediaTipActionDone>{}
      };

    case MediatipActionType.InsertMediatipActionDone:

      var newmediatips = [{ ...action.payload.newmediatip }, ...state.mediatips]
      var tasks = MediaTipTask.ToTasks(newmediatips, action.payload.isManager);
      return {
        ...state,
        isLoading: false,
        mediatipsTasks: tasks,
        mediatips: newmediatips,
        mediatipActionDone: MediaTipActionDone.getAktionUpdateDone(state.mediatips, action.payload.newmediatip),
      };




    case MediatipActionType.UpdateMediatipActionDone:
      const idx = state.mediatips.findIndex(x => x.id == action.payload.mediatip.id);
      var newmediatips = action.payload.removefromStore ? [...state.mediatips.slice(0, idx), ...state.mediatips.slice(idx + 1)]
        : [...state.mediatips.slice(0, idx), { ...action.payload.mediatip }, ...state.mediatips.slice(idx + 1)]
      var tasks = MediaTipTask.ToTasks(newmediatips, action.payload.isManager);
      return {
        ...state,
        isLoading: false,
        bubData: <BubDataResult>{},
        isLoadingbubData: false,
        mediatipsTasks: tasks,
        mediatips: newmediatips,
        mediatipActionDone: MediaTipActionDone.getAktionUpdateDone(state.mediatips, action.payload.mediatip),
      };

    case MediatipActionType.MediatipRemovefromStoreAction:
      const delidxstore = state.mediatips.findIndex(x => x.id == action.payload.mediatip.id);
      if (delidxstore > -1) {
        var deltasks = [...state.mediatips.slice(0, delidxstore), ...state.mediatips.slice(delidxstore + 1)];
        var tasks = MediaTipTask.ToTasks(deltasks, action.payload.isManager);
        return {
          ...state,
          bubData: <BubDataResult>{},
          isLoadingbubData: false,
          isLoading: false,
          mediatipsTasks: tasks,
          mediatips: deltasks,
          mediatipActionDone: <MediaTipActionDone>{}
        };
      }
      return state;

    case MediatipActionType.DeleteMediatipActionDone:
      const delidx = state.mediatips.findIndex(x => x.id == action.payload.mediatipid);
      var deleted = { ...state.mediatips[delidx] };
      var deltasks = [...state.mediatips.slice(0, delidx), ...state.mediatips.slice(delidx + 1)];
      var tasks = MediaTipTask.ToTasks(deltasks, action.payload.isManager);
      return {
        ...state,
        isLoading: false,
        mediatipsTasks: tasks,
        mediatips: deltasks,
        mediatipActionDone: <MediaTipActionDone>{ result: deleted, actionResult: MeditipActionResultEnum.gelöscht },
        currenterror: <SimpleResultError>{}
      };


      case MediatipActionType.MediatipClearErrorAction:
        return {
          ...state,
          isLoading: false,
          currenterror: <SimpleResultError>{}
        };


    case MediatipActionType.MediatipErrorAction:


      var err = SimpleResult.getSimpleResult(action.payload.error)


      return {
        ...state,
        currenterror: err,
        isLoading: false,
        isLoadingbubData: false,
        mediatipActionDone: <MediaTipActionDone>{}
      };

    case MediatipActionType.GetMediatipsAction:
      return {
        ...state,
        isLoading: true,
        currenterror: <SimpleResultError>{},
        bubData: <BubDataResult>{},
        isLoadingbubData: false,
        mediatipActionDone: <MediaTipActionDone>{}
      };
    case MediatipActionType.GetMediatipsActionDone:
      return getMediatipsActionDone(state, action);

    case MediatipActionType.UpdateMediatipActionDone:
      return {
        ...state,
        bubData: <BubDataResult>{},
        isLoadingbubData: false,
        isLoading: false,
        mediatipActionDone: MediaTipActionDone.getAktionUpdateDone(state.mediatips, action.payload.mediatip),
        currenterror: <SimpleResultError>{}
      };

  }
  return state;
}


export function getMediatipsActionDone(state: MediaTipState, action: GetMediatipsActionDone): MediaTipState {
  const tasks = MediaTipTask.ToTasks(action.payload.mediatips, action.payload.isManager)
  return {
    ...state,
    bubData: <BubDataResult>{},
    isLoadingbubData: false,
    mediatips: action.payload.mediatips,
    mediatipsHits: action.payload.mediatips && action.payload.mediatips.length > 0 ? action.payload.mediatips[0].hits : 0,
    isLoading: false,
    mediatipsTasks: tasks,
    mediatipActionDone: <MediaTipActionDone>{},
    currenterror: <SimpleResultError>{}
  };
}
export function getMediatipBubDataActionDone(state: MediaTipState, action: GetMediatipBubDataActionDone): MediaTipState {

  return {
    ...state,
    bubData: action.payload.bubData,
    isLoading: false,
    isLoadingbubData: false,
    mediatipActionDone: <MediaTipActionDone>{},
    currenterror: <SimpleResultError>{}
  };

}

